import { render, staticRenderFns } from "./ContactGroups.vue?vue&type=template&id=3dc13569&scoped=true&"
import script from "./ContactGroups.vue?vue&type=script&lang=js&"
export * from "./ContactGroups.vue?vue&type=script&lang=js&"
import style0 from "./ContactGroups.vue?vue&type=style&index=0&id=3dc13569&prod&lang=scss&scoped=true&"
import style1 from "./ContactGroups.vue?vue&type=style&index=1&id=3dc13569&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc13569",
  null
  
)

export default component.exports